import { getPath } from '@/router/common'

const baseUrl = {
  title: '绑定用户', // 第一页面暂时修改成这个名字后续要修改可以修改
  path: 'ManYunBao'
}

export default [
  {
    path: getPath('BindUser', baseUrl),
    name: 'BindUser',
    component: () => import(/* webpackChunkName: "BindUser" */ '@/views/manYunBao/bindUser/index.vue'),
    meta: {
      title: '绑定用户'
    }
  },
  {
    path: getPath('SignAgreement', baseUrl),
    name: 'ManYunBao_SignAgreement',
    component: () => import(/* webpackChunkName: "ManYunBao_SignAgreement" */ '@/views/manYunBao/signAgreement/index.vue'),
    meta: {
      title: '第②步->满运宝协议'
    }
  }

]
